import React from "react";
import SidebarAdmin from "../../components/SidebarAdmin";
import TopBarTindakLanjut from "../../components/TopBarTindakLanjut";
import TindakLanjutAdmin from "../../components/TindakLanjutAdmin";

function HalamanTindakLanjut() {
  return (
    <div className="profile-page-layout">
      {/* Sidebar kiri */}
      <SidebarAdmin />

      {/* Area kanan */}
      <div className="content">
        <TopBarTindakLanjut />

        {/* Konten utama */}
        <div className="tindak-page">
          <TindakLanjutAdmin/>
        </div>
      </div>
    </div>
  );
}

export default HalamanTindakLanjut;
